/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Contact_SupportInputs */

const en_inbox_contact_support = /** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact SSC Support`)
};

const es_inbox_contact_support = /** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar con Soporte de SSC`)
};

const fr_inbox_contact_support = /** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter le support SSC`)
};

const de_inbox_contact_support = /** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC-Support kontaktieren`)
};

const id_inbox_contact_support = /** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Dukungan SSC`)
};

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const ja_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const zh_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const ar_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const it_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const ru_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const pt_inbox_contact_support = en_inbox_contact_support;

/** @type {(inputs: Inbox_Contact_SupportInputs) => LocalizedString} */
const ko_inbox_contact_support = en_inbox_contact_support;

/**
* | output |
* | --- |
* | "Contact SSC Support" |
*
* @param {Inbox_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_contact_support = /** @type {((inputs?: Inbox_Contact_SupportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Contact_SupportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_contact_support(inputs)
	if (locale === "es") return es_inbox_contact_support(inputs)
	if (locale === "fr") return fr_inbox_contact_support(inputs)
	if (locale === "de") return de_inbox_contact_support(inputs)
	if (locale === "ja") return ja_inbox_contact_support(inputs)
	if (locale === "zh") return zh_inbox_contact_support(inputs)
	if (locale === "ar") return ar_inbox_contact_support(inputs)
	if (locale === "id") return id_inbox_contact_support(inputs)
	if (locale === "it") return it_inbox_contact_support(inputs)
	if (locale === "ru") return ru_inbox_contact_support(inputs)
	if (locale === "pt") return pt_inbox_contact_support(inputs)
	return ko_inbox_contact_support(inputs)
});